import React from "react";
import PropTypes from "prop-types";
import HorizontalStackBar from "../../HorizontalStackBar/HorizontalStackBar";

function TotalServiceStatsBar({ serviceData }) {
  const data = [
    {
      label: "Prima",
      value: serviceData.service.validFirstServices,
      backgroundColor: "#7ed957",
    },
    {
      label: "Ace (Prima)",
      value: serviceData.service.acesOnFirstService,
      backgroundColor: "#2e7d32",
    },
    {
      label: "Seconda",
      value: serviceData.service.validSecondServices,
      backgroundColor: "#4dd0e1",
    },
    {
      label: "Ace (Seconda)",
      value: serviceData.service.acesOnSecondService,
      backgroundColor: "#0288d1",
    },
    {
      label: "Doppio Fallo",
      value: serviceData.service.doubleFaults,
      backgroundColor: "#d32f2f",
    },
  ];
  return (
    <HorizontalStackBar labels={["Servizio"]} data={data} title="Servizio" />
  );
}

TotalServiceStatsBar.propTypes = {
  serviceData: PropTypes.object.isRequired,
};

export default TotalServiceStatsBar;
